<template>
  <div>
    <el-dialog :title="$t('cliente')" :visible.sync="dialog.customer" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item :label="$t('cliente')" prop="customer">
          <CustomerList v-model="form.customer" ref="customer" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.customer = false">Cancelar</el-button>
        <el-button type="primary" @click="clickSave()">Salvar</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('manual')" :visible.sync="dialog.manual" :close-on-click-modal="false">
      <el-form :model="formAudit">
        <el-form-item :label="$t('servico')" prop="customer">
          <el-input v-model="formAudit.serviceCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('objeto')" prop="customer">
          <el-input v-model="formAudit.tag" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('cartao-postagem')" prop="cardpost">
          <el-input v-model="formAudit.cardpost"></el-input>
        </el-form-item>
        <el-row :gutters="5">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('cep-origem')" prop="source">
              <el-input v-model="formAudit.source"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('cep-destino')" prop="destiny">
              <el-input v-model="formAudit.destiny"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('valor')" prop="customer">
          <el-input v-model="formAudit.value" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('peso')" prop="customer">
          <el-input v-model="formAudit.weight"></el-input>
        </el-form-item>
        <el-form-item :label="$t('valor-declarado')" prop="valuedeclared">
          <el-input v-model="formAudit.declaredValue"></el-input>
        </el-form-item>
        <el-form-item :label="$t('valor-tabela')" prop="pricetable">
          <el-input v-model="formAudit.pricetable"></el-input>
        </el-form-item>
        <el-form-item v-if="formAudit.serviceOrderStatus" label="Status Auditoria" prop="serviceOrderStatus">
          <el-input v-model="formAudit.serviceOrderStatus" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="formAudit.serviceOrderStatus" label="Status Prepostagem" prop="prepostStatus">
          <el-select v-model="formAudit.prepostStatus" placeholder="Selecione um status">
            <el-option v-for="item in prepostStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.manual = false">Cancelar</el-button>
        <el-button type="primary" @click="clickSave()">Salvar</el-button>
      </span>
    </el-dialog>
    <el-card v-if="tag">
      <el-descriptions class="margin-top" :title="`Objeto: ${tag.tag}`" :column="3" size="small" border>
        <template slot="extra">
          <el-button-group v-if="tag.pending">
            <el-button plain type="success" @click="send()" size="small">Enviar</el-button>
            <el-button size="small" class="right" plain type="info" @click="igonre()">Ignorar</el-button>
            <el-button size="small" class="right" plain @click="openManual(tag)">Manual</el-button>
            <el-button size="small" class="right" plain @click="openCustomer(save)">Relacionar cliente</el-button>
          </el-button-group>
        </template>
        <el-descriptions-item>
          <template slot="label">
            Cliente
          </template>
          {{ tag.customer }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Serviço
          </template>
          {{ tag.service }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Cartão
          </template>
          {{ tag.cardpost }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Objeto
          </template>
          <tag-link :tag="tag.tag" />
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Peso
          </template>
          {{ tag.weight }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Data
          </template>
          {{ tag.postedAt | dateFormater }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Valor Correio
          </template>
          {{ tag.value }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Valor Tabela
          </template>
          {{ tag.pricetable }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Status
          </template>
          <el-tag :type="tag.pending ? 'danger' : 'success'">{{ tag.pending ? 'Pendente' : 'Já conferido' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            Mensagem
          </template>
          {{ tag.message }}
        </el-descriptions-item>
      </el-descriptions>
      <br />
      <el-table :data="tag.events" stripe size="mini" style="width: 100%">
        <el-table-column width="100" prop="event" label="Evento">
          <template slot-scope="scope">
            {{
              scope.row.event
            }}
          </template>
        </el-table-column>
        <el-table-column width="140" prop="createdAt" label="Data">
          <template slot-scope="scope">
            {{
              scope.row.createdAt | dateFormater
            }}
          </template>
        </el-table-column>
        <el-table-column width="130" prop="username" label="Usuário">
          <template slot-scope="scope">
            {{
              scope.row.username
            }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="Informação">
          <template slot-scope="scope">
            {{
              scope.row.content.message ? scope.row.content.message : ''
            }}
            <el-tag v-show="scope.row.content.value">Valor: {{ scope.row.content.value | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            }) }}</el-tag>
            <el-tag v-show="scope.row.content.weight">Peso: {{ scope.row.content.weight }}</el-tag>
            <el-tag v-show="scope.row.content.oldWeight">Peso ant: {{ scope.row.content.oldWeight }}</el-tag>
            <el-tag v-show="scope.row.content.pricetable">Tabela: {{ scope.row.content.pricetable | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            }) }}</el-tag>
            <el-tag v-show="scope.row.content.oldPricetable">Tabela ant: {{ scope.row.content.oldPricetable |
              currency("R$", 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
              }) }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card v-else>
      <el-row type="flex" justify="end">
        <el-button-group>
          <el-button type="success" plain @click="send()">Enviar</el-button>
          <el-button class="right" plain type="info" @click="igonre()">Ignorar</el-button>
          <el-button class="right" plain @click="openManual(null)">Manual</el-button>
          <el-button class="right" plain @click="openCustomer(save)">Relacionar cliente</el-button>
        </el-button-group>
      </el-row>

      <el-table :data="tableData" stripe ref="tablePrepostAudit" size="mini" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="customer" :label="$t('cliente')">
          <template slot-scope="scope">
            {{ scope.row.customer }} <el-tag v-if="scope.row.packagetable">{{ scope.row.packagetable }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="services" :label="$t('servico')">
          <template slot-scope="scope">
            {{ scope.row.service }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="tag" width="160" :label="$t('objeto')">
          <template slot-scope="scope">
            <tag-link :tag="scope.row.tag" />
          </template>
        </el-table-column>
        <el-table-column sortable prop="value" :label="$t('valor')" align="right">
          <template slot-scope="scope">
            {{
              scope.row.value
              | currency("R$ ", 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
              })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="pricetable" :label="$t('tabela')">
          <template slot-scope="scope">
            {{
              scope.row.pricetable
              | currency("R$ ", 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
              })
            }}
          </template>
        </el-table-column>
        <el-table-column sortable width="90" prop="cardpost" :label="$t('cartao')"></el-table-column>
        <el-table-column sortable width="80" prop="weight" align="right" :label="$t('peso')"></el-table-column>
        <el-table-column sortable prop="date" :label="$t('data')">
          <template slot-scope="scope">
            {{ scope.row.postedAt | dateFormater }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="status" :label="$t('status')" v-if="!type">
          <template slot-scope="scope">
            {{ scope.row.message }}
          </template>
        </el-table-column>
        <el-table-column label="#">
          <template slot-scope="scope">
            <el-button @click="openManual(scope.row)">Corrigir</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="changepage" current-page.sync="page" background layout="prev, pager, next"
        :page-size="100" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import TagLink from '../components/TagLink.vue';
import AuditPendenciesOptions from './AuditPendenciesOptions';
import moment from 'moment';

export default {
  name: "AuditList",
  components: {
    AuditPendenciesOptions,
    CustomerList,
    TagLink,
  },
  props: ['tableData', 'type', 'description', "total", "tag"],
  data() {
    return {
      packageCustomer: '',
      form: {
        customer: "",
        tag: "",
        cardpost: "",
      },
      formAudit: {
        customer: "",
        serviceCode: "",
        declaredValue: 0,
        packagetable: '',
        tag: "",
        value: 0,
        width: 0,
        source: '',
        destiny: '',
        prepost: {
          pricetable: 0,
        },
        prepostStatus: ''
      },
      prepostStatusOptions: [
        { label: 'Pré-postado', value: 1 },
        { label: 'Coletado', value: 2 },
        { label: 'Postado', value: 3 },
        { label: 'Em trânsito', value: 4 },
        { label: 'Entregue', value: 5 },
        { label: 'Cancelado', value: 6 },
        { label: 'Extraviado', value: 7 },
        { label: 'Aferido', value: 8 }
      ],
      dialog: {
        customer: false,
        manual: false,
        card: false,
      },
    }
  },
  filters: {
    dateFormater(date) {
      if (date) {
        return moment.utc(date).utcOffset('+03:00').format('DD/MM/YYYY');
      }

    },
  },
  methods: {
    send() {
      const vm = this;
      const rows = vm.tag ? [vm.tag] : vm.$refs.tablePrepostAudit.selection;
      if (rows.length === 0) {
        return vm.$message({
          type: "error",
          message: "Selecione ao menos um registro para enviar",
        });
      }

      for (const row of rows) {
        if (row.serviceOrderStatus && !row.prepostStatus) {
          return vm.$message({
            type: "error",
            message: `Para o objeto ${row.tag}, o campo Status Prepostagem é obrigatório.`,
          });
        }
      }

      const itemsToSave = rows.map(row => ({
        ...row,
        ...(row.serviceOrderStatus && { prepostStatus: row.prepostStatus }),
      }));

      const loading = vm.$loading(vm.$options.loading);
      AuditService.save(itemsToSave)
        .then((response) => {
          this.$message({
            type: "success",
            message: "Objetos atualizados com successo!",
          });
          vm.$emit('reload');
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.pending) {
        return 'warning-row';
      }
      return '';
    },
    igonre() {
      const vm = this;
      let rows = vm.tag ? [vm.tag] : vm.$refs.tablePrepostAudit.selection;
      if (rows.length === 0) {
        return vm.$message({
          type: "error",
          message: "Selecione ao menos um registro para ignorar",
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.ignore(rows)
        .then((response) => {
          this.$message({
            type: "success",
            message: "Objetos atualizados com successo!",
          });
          vm.$emit('reload');
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    changepage(ev) {
      const vm = this;
      vm.$emit('reload', ev);
    },
    openCustomer(f) {
      const vm = this;
      let rows = vm.tag ? [vm.tag] : vm.$refs.tablePrepostAudit.selection;
      if (rows.length === 0) {
        return vm.$message({
          type: "error",
          message: "Selecione ao menos um registro para relacionar o cliente",
        });
      }
      vm.dialog.customer = true;
      vm.goto = f;
    },
    openManual(row) {
      const vm = this;
      vm.goto = null;
      if (!row && vm.$refs.tablePrepostAudit.selection.length !== 1) {
        return vm.$message({
          type: "error",
          message: "Selecione um registro para editar manualmente",
        });
      }
      const record = row ? row : vm.$refs.tablePrepostAudit.selection[0];
      vm.formAudit = record;
      vm.$set(vm.formAudit, 'prepostStatus', '');
      console.log(row, record);
      vm.dialog.manual = true;
    },
    clickSave() {
      const vm = this;
      vm.dialog.manual = false;
      vm.dialog.customer = false;
      if (vm.goto) {
        vm.goto();
      }
    },
    save() {
      const vm = this;
      if (!vm.form.customer) {
        return vm.$message({ type: "error", message: "Selecione o cliente!" });
      }
      const customer = vm.$refs.customer.customers.find(
        (x) => x.id == vm.form.customer
      );
      if (vm.tag) {
        vm.tag.customer = customer.name;
        vm.tag.customerId = customer.id;
      } else {
        for (const record of vm.$refs.tablePrepostAudit.selection) {
          vm.tableData[
            vm.tableData.findIndex((x) => x.id === record.id)
          ].customer = customer.name;
          vm.tableData[
            vm.tableData.findIndex((x) => x.id === record.id)
          ].customerId = customer.id;
        }
      }
      vm.dialog.customer = false;
    },
    label(percentage) {
      const vm = this;
      if (percentage === 0) {
        return "";
      }
      if (vm.state === 1) return `Importando planilha ${percentage}%`;
      if (vm.state === 2) return `Validando etiquetas ${percentage}%`;
    },
    changeFile(file) {
      var vm = this;
      vm.file = file;
    },
  },
};
</script>
